import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from 'src/app/material.module';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, TablerIconsModule, MaterialModule],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  constructor() { }
  @Input() showToggle = true;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  companyLogo: string = '../../../../../assets/images/logos/codinfos_infos.png';

  ngOnInit(): void {
    const logo = localStorage.getItem('companyLogo');
    if (logo) {
      this.companyLogo = logo;
    }
  }
}
